export enum NewsletterAppMode {
  ListMode = 'list',
  ActionsMode = 'actions',
  LatestMode = 'latest',
  ViewerMode = 'viewer',
  ManageMode = 'manage',
  TestMode = 'test',
}
